// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__27pR9","cardLink":"Card_cardLink__add62","cardImage":"Card_cardImage__3fqaZ","defaultImage":"Card_defaultImage__38mQe","appearCard":"Card_appearCard__3dgR2"};